/**
 * filename：zh.js
 */
export const h = {
  // 通用文本
  home: '首页',
  login: '登录',
  register: '注册',
  logout: '退出登录',
  logoutConfirmMsg: '是否确认退出登录？',
  confirm: '确定',
  cancel: '取消',
  submit: '提交',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  search: '查询',
  reset: '重置',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  index: '序号',
  close: '关闭',
  open: '打开',
  loading: '加载中',
  success: '成功',
  error: '错误',
  warning: '警告',
  info: '信息',
  yes: '是',
  no: '否',
  ok: '好的',
  action: '操作',
  viewDetail: '查看详情',
  language: '语言',
  chinese: '中文',
  english: '英文',

  // 登录注册相关
  loginTitle: '登录',
  emailLogin: '邮箱登录',
  phoneLogin: '手机号登录',
  passwordLogin: '密码登录',
  codeLogin: '验证码登录',
  registerTitle: '注册',
  phoneNumber: '手机号',
  email: '邮箱',
  password: '密码',
  confirmPassword: '确认密码',
  verificationCode: '验证码',
  sendCode: '发送验证码',
  resendCode: '重新发送',
  loginButton: '登录',
  registerButton: '注册',
  forgotPassword: '找回密码',
  rememberPassword: '记住密码',
  loginSuccess: '登录成功！',
  registerSuccess: '注册成功！',
  loginFailed: '登录失败',
  registerFailed: '注册失败',
  pleaseEnterPhone: '请输入手机号',
  mainlandPlayerNotice: '大陆选手请使用"汉英双拼"小程序进行注册登录。',
  pleaseEnterPassword: '请输入密码',
  pleaseEnterCode: '请输入验证码',
  pleaseEnterCorrectPhone: '请输入正确手机号',
  pleaseEnterCorrectEmail: '请输入正确邮箱',
  codeSentSuccess: '验证码发送成功，请注意查收',
  codeSentFailed: '验证码发送失败',
  passwordNotMatch: '两次输入密码不一致',
  phoneRequired: '请输入手机号',
  emailRequired: '请输入邮箱',
  passwordRequired: '请输入密码',
  codeRequired: '请输入验证码',
  passwordLength: '密码长度不能少于6位',
  seconds: '秒后',
  partnerLoginDesc: '组织者登录入口',
  studentLoginDesc: '学生用户登录入口',
  teacherLoginDesc: '教师用户登录入口',
  pleaseChooseLoginType: '请选择登录方式',
  // 导航菜单
  aboutCebsb: '关于CEBSB',
  competitions: '关于赛事',
  forSpellers: '选手专区',
  forSchools: '学校专区',
  globalPartnership: '全球合作伙伴',
  joinUs: '加入我们',
  certificateVerification: '证书查询',
  eLearn: '智学',
  globalFinals: '全球赛',
  FAQ: '常见问题',

  // 关于CEBSB
  background: '背景介绍',
  vision: '愿景',
  committee: '组委会',
  honour: '荣誉',
  history: '历史',

  // 子菜单标题
  backgroundTitle: '·背景介绍',
  visionTitle: '·愿景',
  committeeTitle: '·组委会',
  honourTitle: '·荣誉',
  individualCompetitionsTitle: '·个人赛',
  teamCompetitionsTitle: '·团体赛',
  registerForCompetitionTitle: '·报名参赛',
  onlineLearningResourceTitle: '·在线学习资源',
  characterBankTitle: '·CEBSB-汉字库',
  certificateVerificationTitle: '·证书查询',
  beeFunCarnivalTitle: '·蜂趣嘉年华-未来冠军营',
  teamCompetitionTrainingTitle: '·团体赛培训',
  sisterSchoolEstablishmentTitle: '·姐妹学校建立',
  membershipEnrollmentTitle: '·会员注册',
  beeFunActivityTitle: '·蜂趣活动',
  schoolFaqsTitle: '·常见问题',
  partnerTitle: '·合作伙伴',
  judgesAndCoachesTitle: '·评委和教练',
  volunteersTitle: '·志愿者',

  // 菜单描述文字
  aboutCebsbDesc: 'CEBSB是首个基于拼字大赛并融合中华文化元素的中英双语语言交流活动。CEBSB帮助海内外K-12学习者强化核心语言素养，同时深化对中华文化全球表达和世界多元文化中华理解的认识。',
  competitionsDesc: '赛事包括个人赛和团体赛。基于游戏的竞技活动将中文和英文相结合，学用结合，有效促进拼字者的中英双语习得，强化学习主动性，提升多元文化视野。',
  forSpellersDesc: '这个专属平台为拼字者提升语言素养做好了充分准备。提供在线学习资源、大型字库和丰富多彩的探究营活动，拼字者可以在多个层面和维度轻松找到通往这个迷人的中英双语拼字活动的道路。',
  forSchoolsDesc: '我们愿意与学校密切合作，开展团体赛培训，促进姐妹学校建立，组织蜂趣活动，共同培养具有跨文化思维和全球理解能力的未来人才。',
  joinUsDesc: '我们有一个宏伟的梦想，用多元的语言和文化连接世界，致力于为全世界的年轻人创造一个学习中文和英文、交流思想的平台。如果您对合作有浓厚兴趣，我们将为您提供最广阔的舞台。欢迎加入我们！',

  // 重置密码相关
  resetPassword: '找回密码',
  backToLogin: '返回登录',
  inputEmail: '输入邮箱',
  verify: '验证',
  setNewPassword: '设置新密码',
  complete: '完成',
  verifyRegistrationEmail: '验证注册邮箱',
  nextStep: '下一步',
  verificationCodeSent: '验证码已发送到邮箱',
  pleaseCheckEmail: '请前往邮箱查看',
  setNewPasswordTitle: '设置新密码',
  newPassword: '新密码',
  confirmModify: '确认修改',
  passwordSetComplete: '密码设置完成',
  redirectInSeconds: 's后跳转回登录页',
  redirectNow: '立即跳转',
  pleaseEnterPasswordAgain: '请再次输入密码',
  passwordsDoNotMatch: '两次输入密码不一致!',
  emailCannotBeEmpty: '邮箱不能为空',
  pleaseEnterCorrectEmailFormat: '请输入正确的邮箱格式',
  pleaseEnterVerificationCode: '请输入验证码',

  // 练习相关
  funLearning: '趣味学习',
  practiceExperience: '练习体验',
  challengePractice: '挑战练习',
  limitedTimeFree: '例题',
  questionPaper: '题卷',
  unlockQuestionPapers: '解锁题卷1～4',
  pleaseUnlockFirst: '请先解锁题卷',

  // 答题相关
  exit: '退出',
  skip: '跳过',
  nextQuestion: '下一题',
  confirmSkip: '是否跳过本题？确认跳过将结束体验',
  confirmSkipButton: '确认跳过',
  continueAnswer: '继续答题',
  pleaseSelectAnswer: '请选择答案',
  congratulations: '恭喜答对',
  keepTrying: '很遗憾，再接再厉！',
  goToAnswer: '去答题',
  errorMinus20s: '错误 -20s',
  definition: 'Definition',
  sentenceStr: 'Sentence',
  pinyin: 'Pinyin',
  tip: '提示',

  // 字库相关
  lexiconDirectory: '字库目录',
  chineseEnglishSpellingBee: '汉英双拼大会',
  lexicon: '字库',
  warmReminder: '温馨提示',
  lexiconUnlockNotice: '中国大陆用户可以使用“汉英双拼”微信小程序在小程序内进行词库单独解锁或报名汉英比赛会赠送本组别词库，中国港、澳、台及海外选手不方便使用微信的，需点击右下角进行赛事的报名注册，组委会会统计您的信息，并于1-7个工作日为您处理解锁词库事宜。',
  goToRegister: '去报名',
  // 字库目录相关
  pleaseEnterContent: '请输入内容',
  noData: '暂无数据',
  personalInfo: '个人信息',
  orderPayment: '订单支付',
  chineseEnglishDictionary: '汉英字典',
  studentHomepage: '选手首页',
  funLearningResult: '趣味学习',
  individualCompetitionCityPreliminary: '个人赛城市初选',
  elementaryGroup: '小初组',

  // 赛事相关
  individualCompetition: '个人赛',
  teamCompetition: '团体赛',
  cityPreliminary: '城市初选',
  cityReplay: '城市复选',
  regionalFinal: '区域决选',
  nationalFinal: '全国总决选',
  nationalFinals: '全国总决选',
  preliminaryCompetition: '城市初选',
  divisionFinals: '区域决选',

  // 选手专区
  registerForCompetition: '报名参赛',
  onlineLearningResource: '在线学习资源',
  beeFunCarnival: '蜂趣嘉年华',
  characterBank: '字库',
  characterBankSubtitle: '查看和管理汉字库资源',
  practiceQuestions: '练习题',
  practiceQuestionsSubtitle: '查看和管理练习题资源',
  featureComingSoon: '功能开发中，敬请期待',
  resourceTools: '字库学习',
  competitionPreparation: '备赛',
  faqs: '常见问题',

  // 学校专区
  teamCompetitionTraining: '团体赛培训',
  sisterSchoolEstablishment: '姐妹学校建立',
  membershipEnrollment: '会员注册',
  beeFunActivity: '蜂趣活动',
  schoolFaqs: '学校常见问题',

  // 加入我们
  partner: '合作伙伴',
  judgesAndCoaches: '评委和教练',
  volunteers: '志愿者',

  // 用户中心
  userCenter: '用户中心',
  studentHome: '选手首页',
  orderList: '订单列表',

  // 登录相关
  studentLogin: '学生登录',
  partnerLogin: '组织者登录',
  teacherLogin: '教师端登录',
  welcomeBack: '欢迎回来，请登录您的账户',
  applyForRegistration: '申请注册',
  applyForCommittee: '申请成为组委会',
  applicantName: '申请人姓名',
  applicantPosition: '职务',
  registerEmail: '注册邮箱',
  country: '国家',
  pleaseSelectCountry: '请选择国家',
  pleaseEnterCountry: '请输入您的国家',
  applyReason: '申请原因',
  pleaseEnterApplyReason: '请输入申请原因',
  applySuccess: '申请提交成功',
  applyFailed: '申请提交失败',
  other: '其他',
  progressQuery: '进度查询',
  queryCode: '查询码',
  pleaseEnterQueryCode: '请输入查询码',
  copy: '复制',
  copySuccess: '复制成功',
  copyFailed: '复制失败',
  queryProgress: '查询进度',
  queryFailed: '查询失败',
  applicationStatus: '申请状态',
  applicationTime: '申请时间',
  reviewTime: '审核时间',
  reviewResult: '审核结果',
  reviewRemark: '审核备注',
  rejectionReason: '拒绝原因',
  reapply: '重新申请',
  loginNow: '立即登录',
  approvalCongratulations: '恭喜您已通过审核，成为官方组委会一员，期待今后与您的合作！',
  pendingNotice: '您的提交正在审核中，审核周期1-5个工作日，请关注您的随时邮箱信息，感谢您的理解！',

  // 管理后台
  partnerDashboard: '机构管理后台',
  schoolManage: '学校管理',
  schoolManageSubtitle: '管理合作学校信息与相关数据',
  schoolManageComingSoon: '学校管理功能开发中，敬请期待',
  schoolList: '学校列表',
  addSchool: '新增学校',
  schoolAddress: '学校地址',
  teacherName: '教师姓名',
  teacherEmail: '教师邮箱',
  pleaseEnterSchoolName: '请输入学校名称',
  pleaseEnterSchoolAddress: '请输入学校地址',
  pleaseEnterTeacherName: '请输入教师姓名',
  pleaseEnterTeacherEmail: '请输入教师邮箱',
  pleaseEnterValidEmail: '请输入正确的邮箱地址',
  organizationInfo: '机构信息',
  managerInfo: '负责人信息',
  examSystem: '赛务管理',
  examManagement: '考务管理',
  examTimeManagement: '时间管理',
  examTimeList: '时间安排列表',
  addExamTime: '新增时间安排',
  editExamTime: '编辑时间安排',
  examStartTime: '比赛开始时间',
  examEndTime: '比赛结束时间',
  releaseTime: '公布成绩时间',
  pleaseSelectStartTime: '请选择开始时间',
  pleaseSelectEndTime: '请选择结束时间',
  publishSelectTime: '请选择公布成绩时间',
  endTimeMustAfterStartTime: '结束时间必须大于开始时间',
  publishTimeMustAfterEndTime: '成绩发布时间必须大于结束时间',
  publishTimeMustAfterStartTime: '发布时间必须晚于开始时间',
  confirmDeleteExamTime: '确定要删除该时间安排吗？',
  individualScoreQuery: '个人赛成绩查询',
  judgeSystem: '裁判系统',
  playerInfo: '选手信息',
  organizationName: '机构名称',
  organizationCode: '机构代码',
  contactPerson: '联系人',
  contactPhone: '联系电话',
  contactEmail: '联系邮箱',
  contactInfo: '联系人信息',
  organizationEmail: '组委会邮箱',
  organizationPhone: '组委会联系方式',
  address: '地址',
  managerName: '负责人姓名',
  managerPhone: '负责人电话',
  managerEmail: '负责人邮箱',
  content: '内容',
  title: '标题',

  // 表单相关
  pleaseSelect: '请选择',
  pleaseInput: '请输入',
  required: '必填',
  optional: '可选',
  name: '姓名',
  gender: '性别',
  age: '年龄',
  grade: '年级',
  class: '班级',
  school: '学校',
  phone: '电话',
  wechat: '微信',
  qq: 'QQ',

  // 比赛相关
  competition: '比赛',
  exam: '考试',
  score: '成绩',
  ranking: '排名',
  certificate: '证书',
  award: '奖项',
  prize: '奖品',

  // 学习相关
  study: '学习',
  practice: '练习',
  test: '测试',
  homework: '作业',
  course: '课程',
  lesson: '课程',
  chapter: '章节',
  word: '单词',
  grammar: '语法',
  vocabulary: '词汇',
  pronunciation: '发音',
  listening: '听力',
  speaking: '口语',
  reading: '阅读',
  writing: '写作',

  // 时间相关
  today: '今天',
  yesterday: '昨天',
  tomorrow: '明天',
  thisWeek: '本周',
  lastWeek: '上周',
  nextWeek: '下周',
  thisMonth: '本月',
  lastMonth: '上月',
  nextMonth: '下月',
  thisYear: '今年',
  lastYear: '去年',
  nextYear: '明年',

  // 状态相关
  pending: '待处理',
  processing: '处理中',
  completed: '已完成',
  cancelled: '已取消',
  approved: '已通过',
  rejected: '已拒绝',
  active: '活跃',
  inactive: '不活跃',
  online: '在线',
  offline: '离线',
  checkRegistrationFailed: '您还没有完善个人信息，请先完善个人信息！',
  incompleteInfoTitle: '提示',
  incompleteInfoMessage: '您还没有完善个人信息，请先完善个人信息后才能报名参赛。',
  goToCompleteInfo: '去完善',
  // 首页相关
  wordEnlightens: '词汇启迪',
  world: '世界',
  homeDescription: '让您的真正潜力在汉英双语拼字大赛中闪耀！',

  // 原有内容
  title1: '个人赛考量申请列表',
  back1: '返回首页',
  contentStr1: '申请考量信息',
  contentStr2: '个人赛考量信息',
  contentStr3: '(注*因涉及到试卷数量申请，请仔细填写申请信息，谢谢!)',
  contentStr4: '预计考试时间',
  contentStr411: '赛季',
  contentStr5: '预计考试时间',
  contentStr6: '学校省市区',
  contentStr7: '学校名称',
  contentStr8: '参赛包含年级',
  contentStr9: '每年级班级数',
  contentStr10: '预计考量',
  contentStr11: '备注(非必填)',
  contentStr12: '请填写备注信息',
  contentStr13: '邮寄信息',
  contentStr14: '注*因涉及到比赛资料邮寄，请仔细填写邮寄信息，谢谢！',
  contentStr15: '收件人姓名',
  contentStr16: '收件人联系方式',
  contentStr17: '邮箱',
  contentStr18: '收货地址',
  contentStr19: '详细地址',
  contentStr20: '注*因涉及到物料准备，请务必认真填写，一旦提交无法修改本次申请，如需修改，请联系赛区组委会老师！',
  contentStr21: '赛区组委会老师！',
  contentStr22: '提交考量信息',
  contentStr23: '申请成功，请等待组委会和您联系',
  contentStr24: '提交成功，请您耐心等待组委会审核！',
  contentStr25: '团体赛参赛申请',
  contentStr26: '提交信息',
  contentStr27: '资格审核',
  contentStr28: '报名缴费',
  contentStr29: '俱乐部组别',
  contentStr30: '指导教师姓名',
  contentStr31: '指导教师联系方式',
  contentStr32: '拟参赛队伍数量',
  contentStr33: '俱乐部名称',
  contentStr34: '1、ITSO x 团体赛战队年度注册费用:480元/队/赛季;',
  contentStr35: '2、每所学校同一组别最多可报名2支队伍;',
  contentStr36: '3、注册队伍提交注册信息后,经组委会审核确认后,方可完成注册;',
  contentStr37: '4、注册费用涵盖：2024-25赛季ITSOx团体赛全国总决选参赛资格，参赛代码证书，官方统一培训，2024-25赛季官方词库手册2本、线上词库大礼包1个；',
  contentStr38: '5、如注册队伍缴纳年度注册费用后,因学校或学生个人原因无法参与本年度后续比赛活动,年度注册费用不支持退费,但注册队伍仍然享有以上权益;',
  contentStr39: '6、队伍注册成功后,将会获得带有组委会唯一识别编码资格证书,该证书本年度有效,并可在SPBCN官方网站进行查询验证;',
  contentStr40: '资料审核中',
  contentStr41: '缴费状态',
  contentStr42: '未缴费',
  contentStr43: '参赛资格证书已生成，点击查看',
  contentStr44: '审核失败',
  contentStr45: '序号',
  contentStr46: '暂无考量申请数据',
  contentStr47: '总考量',
  contentStr48: '预计考试时间',
  contentStr49: '查看详情',
  contentStr50: '操作',
  contentStr51: '请选择',
  contentStr52: '请输入',
  contentStr53: '请输入邮箱（用于发送考试使用音频等文件）',
  contentStr54: '例：镇（街道），xx小区x号楼x单元门牌号',
  contentStr55: '等待组委会邮寄试卷',
  contentStr56: '等待接收试卷',
  contentStr57: '再逛逛',
  contentStr58: '审核通过',
  contentStr59: '已退款',
  contentStr60: '重新提交报名信息',
  contentStr61: '已缴费',
  contentStr62: '参赛证书',
  contentStr63: '下 载',
  contentStr64: '关 闭',
  contentStr65: '未通过原因是:',
  contentStr66: '班',
  contentStr67: '学校登录',
  contentStr68: '请输入手机号',
  contentStr69: '返回首页',
  contentStr70: '手机号',
  contentStr71: '请输入手机号',
  contentStr72: '验证码',
  contentStr73: '请输入验证码',
  contentStr74: '登录',
  contentStr75: '请输入正确手机号',
  contentStr76: '短信发送成功，请注意查收',
  contentStr77: '登录成功！',
  contentStr78: '发送验证码',
  contentStr79: '负责老师',
  contentStr80: '注 册',
  contentStr81: '暂未开放，敬请期待!',
  contentStr82: '恭喜您，注册成功！',
  contentStr83: '提示',
  contentStr84: '确定',
  contentStr85: '取消',
  studyPlan1: '学习计划',
  studyPlanNoData: '暂未创建学习计划',
  studyPlanCreate: '创建',
  studyPlanCancel: '取 消',
  studyPlanSubmit: '提 交',
  formItem1: '计划名称',
  formItem2: '计划类型',
  formItem3: '一级属性',
  formItem4: '二级属性',
  formItem5: '起止时间',
  formTypeWeek: '周计划',
  formTypeMonth: '月计划',
  formTypeSemester: '学期计划',
  formTypeYear: '学年计划',
  rsp: '至',
  sp: '开始日期',
  ep: '结束日期',
  np: '请输入计划名称',
  tp: '请选择计划类型',
  rtp: '请选择起止时间',
  oneLevelAP: '例：年级',
  oneLevelBP: '例：一年级',
  twoLevelAP: '例：班级',
  twoLevelBP: '例：1',
  createTime: '创建时间',
  creator: '创建者',
  state: '状态',
  toWord: '查看单词列表',
  studyPlan2: '学习计划单词列表',
  wordListNoData: '暂无单词数据',
  importWords: '批量导入单词',
  importWordsWithScan: '扫读笔导入单词',
  downLoadTemplate: '下载模版',
  uploadExcel: '确认上传',
  chooseExcel: '选取文件',
  wordListTip1: '1、下载Excel模版',
  wordListTip2: '2、按模版要求修改文件',
  wordListTip3: '3、点击下方按钮选取文件',
  wordListTip4: '4、确认无误后，点击确认上传',
  spell: '单词',
  taskType: '教学任务',
  source: '来源',
  difficulty: '难度',
  del: '删除',
  delAsk: '确认删除该单词?',
  spellP: '请输入单词',
  hadDel: '已删除',
  stuP: '请输入姓名',
  phoneP: '请输入手机号',
  importStudent: '批量导入学生名单',
  import: '批量导入',
  studentNoData: '暂无学生数据',
  addbtn: '添加学生',
  stuName: '学生姓名',
  chooseFileFirst: '请先选择要上传的文件',
  uploadSucc: '批量上传成功',
  failReason: '请修改后再上传，失败原因:',
  failUpload: '上传失败',
  addSucc: '添加成功',
  comfirmToAdd: '确认添加',
  state1: '正常',
  state2: '禁用',
  delAsk2: '确认删除该学生？',
  base: '达标',
  increase: '提高',
  extra: '思考',
  planManagement: '计划管理',
  studentManagement: '学生管理',
  scanNotes1: '1，需要使用同手机号的微信进行授权登录扫读笔蜂道具\n2，在网站勾选需要上传单词的计划列表左侧勾选框，点击底部开始上传按钮\n3，点击扫读笔扫描结果的单词即可上传该单词到计划内\n4，上传结束后点击结束上传按钮结束本次上传。',
  moreOperation: '更多操作',
  beginUpLoad: '开始上传',
  endUpLoad: '结束上传',
  upLoadEndTips: '是否确认结束当前上传任务？',
  upLoadEndTips2: '*请您在扫读笔上进行扫描，并选择上传单词操作，上传结束后请点击结束上传按钮，请勿刷新该界面',
  reloading: '加载中',
  clickedReloading: '点击刷新',
  competitionPlan: '竞技计划',
  // 选手界面相关
  studentDashboard: '选手中心',
  account: '账号',
  lexiconStudy: '词库学习',
  exerciseTraining: '题型训练',
  myhomework: '作业',
  enterUnlockCode: '请输入解锁码',
  unlockCode: '解锁码',
  unlockNow: '立即解锁',
  unlockSuccess: '解锁成功',
  unlockFailed: '解锁失败',
  registrationSuccessMessage: '您已报名成功，请前往备赛，预祝取得好的成绩。',
  welcomeToStudentCenter: '欢迎来到选手中心',
  userInformation: '用户信息',
  competitionRegistration: '注册比赛',
  registrationCompleted: '报名已完成',
  learningFunctions: '学习功能',
  lexiconStudyDesc: '丰富的词库资源，助您提升词汇量',
  exerciseTrainingDesc: '多样化的题型训练，提升答题能力',
  selectUnlockMethod: '选择解锁方式',
  paymentUnlock: '缴费解锁',
  paymentUnlockDesc: '通过缴费方式解锁报名',
  codeUnlock: '兑换码解锁',
  codeUnlockDesc: '使用兑换码解锁报名',
  unlockCodeTip: '请输入您的解锁码，解锁后即可完成报名',
  noUnlockCode: '无兑换码？',
  clickToApply: '点击申请',
  applyUnlockCode: '申请兑换码',
  applyUnlockCodeRemark: '申请备注信息',
  pleaseEnterApplyRemark: '请输入申请备注信息',
  applyUnlockCodeNotice: '申请后组委会会在1-7个工作日内审核通过后给您发送兑换码邮件，请注意查收！',
  confirmApply: '确认申请',
  registrationSuccess: '报名成功',
  applySuccessTip: '您的申请已提交成功，请耐心等待。组委会会在1-7个工作日内审核通过后给您发送兑换码邮件，请注意查收！',
  codeManagement: '兑换码管理',
  codeManagementDesc: '兑换码的发放与导出功能',
  userSignUpList: '用户报名信息列表',
  userSignUpInfo: '用户报名信息',
  promotion: '是否晋级',
  promoted: '已晋级',
  notPromoted: '未晋级',
  notSet: '未设置',
  enrollmentTime: '报名时间',
  pleaseSelectCommittee: '请选择组委会',
  toolManagement: '工具管理',
  // 兑换码管理相关
  infoFilter: '信息筛选',
  season: '赛季',
  pleaseSelectSeason: '请选择赛季',
  unlockRaceSchedule: '解锁赛程',
  isUsed: '是否使用',
  codeInfo: '兑换码信息',
  batchExport: '批量导出',
  serialNumber: '序号',
  raceSchedule: '赛程',
  assignedDistrict: '分配赛区',
  validDays: '有效天数',
  used: '已使用',
  unused: '未使用',
  userName: '使用人',
  useTime: '使用时间',
  description: '描述信息',
  operation: '操作',
  confirmDelete: '确认删除该兑换码吗？',
  deleteSuccess: '删除成功',
  exportSuccess: '导出成功',
  exportFailed: '导出失败',
  selectRaceSchedule: '选择赛程',
  pleaseSelectRaceSchedule: '请选择赛程',
  selectRaceScheduleTip: '请选择您要报名的赛程，系统将自动检查您的参赛资格',
  noQualification: '您没有该赛程的参赛资格',
  checkQualificationFailed: '查询参赛资格失败',
  registrationSuccessNotice: '您已报名成功，请关注组委会信息避免错过作答时间！',
  // 用户信息编辑相关
  editUserInfo: '编辑用户信息',
  avatar: '头像',
  uploadAvatar: '上传头像',
  cardType: '证件类型',
  idCard: '证件号码',
  level: '组别',
  nationality: '国籍',
  nationalityCode: '国籍代码',
  sex: '性别',
  pleaseEnterName: '请输入姓名',
  pleaseSelectCardType: '请选择证件类型',
  pleaseEnterIdCard: '请输入证件号码',
  pleaseSelectLevel: '请选择组别',
  pleaseSelectNationality: '请选择组委会',
  pleaseEnterNationalityCode: '请输入国籍代码',
  pleaseSelectSex: '请选择性别',
  photoPreview: '照片预览',
  settings: '设置',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败',
  // 组别
  groupPrimary: '小初组（1-2年级）',
  groupMiddle: '小中组（3-4年级）',
  groupHigh: '小高组（5-6年级）',
  groupJunior: '初中组（7-9年级）',
  groupSenior: '高中组（10-12年级）',
  // 证件类型
  idCardTypeIdCard: '身份证',
  idCardTypePassport: '护照',
  // 性别
  sexMale: '男',
  sexFemale: '女',
  // 报名区域功能
  startCompetition: '开始比赛',
  scoreQuery: '成绩查询',
  feedback: '信息反馈',
  message: '消息',
  notOpen: '暂未开放',
  // 消息列表
  all: '全部',
  unread: '未读',
  read: '已读',
  messageDetail: '消息详情',
  // 申请兑换码
  sendEmailNotification: '是否发送邮件通知申请结果？',
  // 解锁成功
  unlockSuccessMessage: '恭喜您报名成功，请积极备赛争取夺得好成绩！',
  // 发送邮件相关
  sendEmail: '发送邮件',
  recipient: '收件人',
  emailContent: '邮件内容',
  defaultEmailContent: '您好，您的兑换码已生成，请查收。',
  sendEmailSuccess: '邮件发送成功',
  sendEmailFailed: '邮件发送失败',
  pleaseEnterEmail: '请输入邮箱',
  redemptionCode: '兑换码',
  tips: '提示',
  later: '稍后再说',
  identityNotAuthorizedMsg: '您还不是组委会老师，请点击下方申请注册按钮，先提交申请信息，感谢您的理解和支持！',
  statistics: '数据统计',
  people: '人',
  deleteQualification: '删除参赛资格',
  editPromotion: '修改晋级',
  regionalQualification: '区域赛资格',
  qualificationCode: '资格码',
  isPay: '是否支付',
  notPaid: '未支付',
  paid: '已支付',
  scoreNotFound: '未查询到您的成绩',
  scoreNotFoundDesc: '抱歉，当前赛程暂未查询到您的成绩信息，请稍后再试或联系客服。',
  congratulationsPromoted: '恭喜您成功晋级！',
  notPromotedMessage: '很遗憾，您未能晋级，请继续努力！',
  selectRaceScheduleForScoreQuery: '选择赛程查询成绩',
  selectRaceScheduleForScoreQueryTip: '请选择要查询成绩的赛程',
  query: '查询',
  registerRegionalFinal: '报名区域决选',
  registerNationalFinals: '报名全球总决选',
  isAllocated: '是否分配',
  allocated: '已分配',
  notAllocated: '未分配',
  allocatedEmail: '已分配邮箱',
  expand: '展开',
  collapse: '收起',
  noAllocatedEmail: '暂无分配邮箱信息',
  // 选手注册信息详情页面
  playerRegistInfoDetails: '选手注册信息详情',
  getTempCode: '获取临时验证码',
  getTempCodeFailed: '获取临时验证码失败',
  male: '男',
  female: '女',
  idCardType: '证件类型',
  passport: '护照',
  schoolProvinceCity: '学校省市区',
  addressInfo: '地址信息',
  receiptName: '收件人姓名',
  receiptPhone: '收件人手机号',
  provinceCityArea: '省市区',
  detailAddress: '详细地址',
  defaultAddress: '默认地址',
  couponInfo: '优惠券信息',
  coupon: '优惠券',
  discountAmount: '优惠金额',
  couponType: '优惠券类型',
  fullReduction: '满减',
  noThreshold: '无门槛',
  minimumPurchase: '最低购买金额',
  expirationDate: '有效期',
  useStatus: '使用状态',
  useDate: '使用/撤回/过期日期',
  couponStatus: '优惠券状态',
  onShelf: '已上架',
  offShelf: '已下架',
  enrollmentInfo: '报名信息',
  contact: '联系方式',
  productName: '产品名称',
  openType: '开通类型',
  participationMethod: '参赛方式',
  answered: '已答题',
  notAnswered: '未答题',
  openTime: '开通时间',
  orderInfo: '订单信息',
  expiryDate: '赠送词库到期时间',
  quantity: '数量',
  totalPrice: '总价',
  unitPrice: '单价',
  orderName: '订单名称',
  orderAmount: '订单金额',
  paymentAmount: '实付金额',
  orderSource: '订单来源',
  orderTime: '下单时间',
  isSend: '是否寄送',
  needSend: '需要寄送',
  noNeedSend: '无需寄送',
  orderStatus: '订单状态',
  unknown: '未知',
  schoolName: '学校名',
  orderNo: '订单号',
  // 全国总决选页面
  areaPromoteNoPayPlayer: '区域赛晋级未缴费选手',
  nationalFinalPlayerInfo: '总决选选手信息',
  playerInfoFilter: '选手信息筛选',
  pleaseSelectType: '请选择类型',
  paymentStatus: '支付状态',
  playerInfoList: '选手信息列表',
  nationalFinalNo: '国赛编号',
  personalInfoDetails: '个人信息详情',
  personalDetailInfo: '个人详细信息',
  detailCompleted: '已完善',
  detailIncomplete: '未完善',
  playerIdentity: '选手身份',
  englishNationalPromoted: '英文国赛晋级',
  regionalFinalPromoted: '区域决选晋级',
  reviewStage: '审核阶段',
  orderDetails: '订单详情',
  editReviewStatus: '修改审核状态',
  nationalFinalOrderInfo: '总决选订单信息',
  basicInfo: '基本信息',
  detailInfo: '详细信息',
  schoolLocation: '学校所在地',
  englishName: '英文名',
  birthDate: '出生日期',
  yearsOld: '岁',
  chineseZodiac: '生肖',
  zodiac: '星座',
  prizeMailAddress: '奖品邮寄地址',
  fatherContact: '父亲联系方式',
  motherContact: '母亲联系方式',
  playerHeight: '选手身高',
  playerWeight: '选手体重',
  accompanyingParentHeightWeight: '随行家长身高体重',
  number: '第',
  position: '位',
  motto: '座右铭',
  hardestChineseCharacter: '目前对自己最难的汉字',
  hobbies: '兴趣爱好',
  favoriteBook: '最喜欢的书籍',
  favoriteSport: '最喜欢的运动',
  favoriteSubject: '最喜欢的学科',
  messageToOtherPlayers: '对参加比赛其他选手的寄语',
  significanceOfNationalCompetition: '国家级比赛对于本人的意义',
  whatWouldYouDoWithPrize: '如果你赢得了奖金，你会做什么？',
  playerNotCompleteDetailInfo: '选手还未完善详细信息～',
  noOrderInfo: '暂无订单信息～',
  orderPaid: '订单已支付',
  orderNotPaid: '订单未支付',
  offlinePayment: '线下支付',
  paymentMethod: '支付方式',
  paymentVoucher: '支付凭证',
  clickToViewLargeImage: '点击查看大图',
  paidProducts: '付费产品',
  giftProducts: '赠送产品',
  items: '项',
  free: '免费',
  totalAmount: '费用合计',
  confirmPayment: '确认支付',
  reviewStatus: '审核状态',
  pleaseSelectReviewStatus: '请选择审核状态',
  pendingReview: '未审核',
  reviewRejected: '驳回',
  reviewApproved: '通过',
  uploadPaymentVoucher: '上传支付凭证',
  uploadPaymentVoucherNotice: '上传支付凭证后，订单状态变为"已支付"。如需修改订单，仍可在订单详情中修改订单详情和订单价格。',
  uploadImage: '上传图片',
  pleaseUploadImageFormat: '请上传图片格式',
  confirmModifyPaymentStatus: '是否确认修改缴费信息状态?',
  confirmSuccess: '确认成功',
  reviewStatusUpdateSuccess: '审核状态修改成功',
  confirmModifyOrderPrice: '确认修改订单价格？',
  orderPriceUpdateSuccess: '订单价格修改成功',
  updateFailed: '修改失败',
  addFailed: '添加失败',
  pleaseEnterModifyRemark: '请输入修改备注信息',
  confirmModifyAgain: '请再次确认是否修改?',
  updateSuccess: '修改成功',
  remark: '备注',
  // 区域赛晋级未缴费选手页面
  group: '组别',
  pleaseEnter: '请输入',
  confirmOrderInfo: '确认订单信息',
  pleaseEnterRemark: '请输入备注信息',
  confirmOfflinePayment: '确认线下支付',
  uploadPaymentVoucherRequired: '请上传缴费凭证',
  confirmOfflinePaymentSuccess: '确认线下支付成功',
  playerSubmittedOrderNotice: '该选手已在微信小程序中提交订单，请在"总决选选手信息"列表中查询此选手，进行线下支付操作。',
  // 试卷管理
  examPaperManagement: '试卷管理',
  examPaperManagementDesc: '试卷的创建、编辑和管理功能',
  examPaperDownload: '试卷下载',
  examPaperDownloadMenuDesc: '下载各组别试卷图片与音频文件',
  examPaperDownloadCenter: '试卷下载中心',
  examPaperDownloadDesc: '按组别下载试卷图片与配套音频（示例链接，可后续替换）',
  batchDownloadAll: '批量下载全部',
  examPaperImageFile: '试卷图片',
  audioFile: '音频文件',
  preview: '预览',
  audioPreview: '试听',
  downloadExamPaperImage: '下载试卷图片',
  downloadAudio: '下载音频',
  groupPrimarySimple: '小初组',
  groupMiddleSimple: '小中组',
  groupHighSimple: '小高组',
  groupJuniorSimple: '初中组',
  downloadUrlMissing: '下载地址不存在',
  onlyHttpsDownload: '仅支持 HTTPS 下载地址，请检查链接',
  downloadFallbackTip: '当前资源不支持直接下载，已尝试打开原链接，请检查文件服务是否允许跨域下载',
  batchDownloadTriggered: '已触发批量下载，请在浏览器中允许多文件下载',
  batchZipSuccess: '压缩包已生成并开始下载',
  batchZipFailed: '压缩包生成失败，请稍后重试',
  batchZipAllFailed: '全部文件下载失败，无法生成压缩包',
  batchZipPartialSuccess: '压缩包已下载，但有 {count} 个文件获取失败',
  examPaperList: '试卷列表',
  conditionFilter: '条件筛选',
  examPaperName: '试卷名称',
  examPaperType: '试卷类型',
  pleaseEnterExamPaperName: '请输入试卷名称',
  pleaseSelectExamPaperType: '请选择试卷类型',
  addExamPaper: '新增试卷',
  formalExamPaper: '正式考题',
  backupExamPaper: '备用考题',
  examPaperNameCol: '试卷名称',
  seasonCol: '赛季',
  districtCol: '赛区',
  groupCol: '组别',
  setCol: 'Set',
  statusCol: '是否启用',
  enabled: '已启用',
  disabled: '未启用',
  editExamPaper: '编辑',
  deleteExamPaper: '删除',
  confirmDeleteExamPaper: '是否确认删除该试卷?',
  set: 'Set',
  district: '赛区',
  raceScheduleCol: '所属赛程',
  pleaseSelectDistrict: '请选择赛区',
  pleaseSelectRaceScheduleCol: '请选择赛程',
  pleaseSelectSet: '请选择Set',
  status: '是否启用',
  pleaseSelectStatus: '请选择状态',
  // 试卷编辑相关
  examPaperDetail: '试卷详情',
  questionTypeSettings: '题型设置',
  questionTypeSettingsNote: '(注*选择顺序即题型答题顺序)',
  questionNum: '题数',
  pleaseEnterQuestionNum: '请输入题目数量',
  questionTypeScore: '分数',
  pleaseEnterScore: '请输入题目分数',
  confirmQuestionType: '确认题型',
  resetQuestionType: '重置题型',
  questionList: '题目列表',
  editQuestion: '编辑',
  editQuestionNote: '(注*不编辑题目系统将在题库随机抽取本组别题目)',
  questionScore: '题目分数',
  inLexicon: '是否在词库内',
  inLexiconYes: '词库内',
  inLexiconNo: '词库外',
  isTestQuestion: '是否为测试题',
  isTestQuestionYes: '是',
  isTestQuestionNo: '否',
  wordCategory: '单词类别',
  pleaseSelectQuestionType: '请选择题型',
  questionBankList: '题库列表',
  saveCurrentQuestions: '保存当前题目',
  questionTypeName: '题型名称',
  questionAnswer: '题目答案',
  pleaseEnterWord: '请输入单词',
  inLexiconFilter: '含在词库中',
  confirmDeleteQuestion: '确定要删除这道题目吗？',
  text: '文字',
  pleaseEnterText: '请输入文字',
  clickToSelect: '点击选择',
  dragToReorder: '长按拖拽排序',
  totalQuestions: '题目总数',
  noQuestionTypeSelected: '请先选择题型并确认',
  noQuestionData: '暂无题目数据',
  examTimeManagementDesc: '创建、编辑和管理时间安排',
  confirmResetQuestionType: '确定要重置题型设置吗？重置后将清空所有已选择的题型和题目数据。',

  classManage: '班级管理',
  trialClassManage: '体验课',
  schoolPicUrl: '学校LOGO',
  foundingYear: '建校时间',
  schoolMotto: '校训',
  schoolProfile: '学校简介',
  addTeacher: '添加教师',
  schoolInfo: '学校信息',
  teachers: '教师管理',
  username: '用户名',
  openState: '启用',
  closeState: '禁用',
  createGrade: '创建班级',
  editGrade: '修改班级名称',
  createClass: '创建体验课',
  editClass: '修改体验课',
  courseName: '体验课名称',
  optionalChineseCharacters: '可选择汉字',
  selectedChineseCharacters: '已选择汉字',
  pleaseInputName: '请输入体验课名称',
  pleaseSelectClass: '请选择班级',
  pleaseSelectWord: '请选择汉字',
  startCourse: '开始学习',
  State: '州',
  pleaseSelectState: '请选择州',
  pleaseSelectSchool: '请选择学校',
  pleaseInputSchool: '请输入学校名称',
  completeInformation: '请完善个人信息',

  getSchoolListFailed: '获取学校列表失败',
  getGradeListFailed: '获取年级/班级列表失败',
  createGradeSuccess: '创建成功',
  operateFailed: '操作失败',
  confirmDeleteClass: '确认删除该班级吗？',
  editSuccess: '修改成功',
  pleaseEnterClassName: '请输入班级名称',
  pleaseEnterGrade: '请输入/选择年级',

  backToClassManage: '返回班级管理',
  studentListOfClass: '学生列表',
  downloadStudentTemplate: '下载导入模板',
  batchDeleteStudents: '批量删除',
  confirmBatchDeleteStudents: '确认批量删除所选学生吗？',
  noClassSelected: '请从班级管理进入并选择班级',
  addOverseasStudent: '添加学生',
  identity: '身份',
  identity3: '国家组委会',
  identity2: '学校组委会',
  identity4: '教师',
  noschool: '没有您的学校？点此添加',
  selschool: '去选择学校',
  match: '对抗赛',
  noData1: '暂未分配赛区',
  createMatch: '创建对抗赛',
  matchName: '对抗赛名称',
  pleaseInputName2: '请输入名称',
  grouping: '分组',
  createPaper: '组卷',
  groupName: '小组名称',
  num: '号码',
  choosed: '已选择',
  canChoose: '可选择',
  showQRcode: '二维码',
  startMatch: '进入比赛',
  ready: '准备',
  start: '开始',
  end: '结束',
  ing: '进行中',
  groupTip: '建议每组人数尽量相同',
  paperTip: '建议题目数量大于或等于每组人数',
  autoGroup: '一键分组',
  readySucc: '已准备',
  startSucc: '开始答题',
  endSucc: '结束答题',
  readyIng: '准备中',
  startIng: '答题中',
  endIng: '已结束',
  result: '查看结果',
  noPeople: '作答人数不足',
  pleaseWait: '比赛即将开始，请耐心等待',
  users: '本设备作答选手',
  readyTip: '请准备，比赛即将开始',
  completeTip: '本题已提交',
  resetSucc: '已重置',
  answer: '答案',
  searchFont: '查找汉字',
  tipContent: '超过最大连接数，请刷新重试',

  // 学生端赛前入口 beforeEnter（/stu/examSemi/be）
  examBeforePageTitleDefault: '线上答题',
  examBeforeSubtitle: '请在安静网络环境中完成作答',
  examBeforeInstructions: '答题说明',
  examBeforeTipDevice: '设备建议',
  examBeforeTipDeviceHint: '电脑 / 平板优先',
  examBeforeTipNetwork: '网络建议',
  examBeforeTipNetworkHint: '请保持网络稳定',
  examBeforeTipStatus: '作答状态',
  examBeforeTipStatusHint: '系统自动同步进度',
  examBeforeDefer: '暂不作答',
  examBeforeStart: '开始答题',
  examBeforeRefresh: '刷新',
  examBeforeConfirmPlayerTitle: '请确认选手信息',
  examAnswering: '答题',

  // 网站首页
  homes1rounds: '轮次',
  homes1roundsDesc: '智学 - 初赛 - 国家/地区决赛 - 全球总决赛',
  homes1culture: '文化',
  homes1cultureDesc: '全球首创汉英双语拼词竞技赛事，融合汉字文化与国际英文拼写',
  homes1target: '目标',
  homes1targetDesc: '以赛促学，搭建全球青少年跨文化双语交流平台',

  homes2tit: 'OUR HONOR 历届冠军',
  homes2nationalChampion: 'CEBSB 全国总冠军',
  homes2ChampionInterviews: '冠军专访',
  homes2tab1name: '李端昂',
  homes2tab1area: '天津赛区',
  homes2tab1grade: '七年级',
  homes2tab2name: '靳浩',
  homes2tab2area: '上海赛区',
  homes2tab2grade: '六年级',
  homes2tab3name: '潘祐祺',
  homes2tab3area: '上海赛区',
  homes2tab3grade: '一年级',

  // section3 E-LEARN
  homes3tit: 'E-LEARN 智学资源',
  homes3ELearnKit: '智学礼包',
  homes3ELearnKitDesc: '官方字库 + 极速拼字游戏盒 + 神兽盲盒潮玩，三位一体，有趣有料。',
  homes3MiniProgram: '智学小程序',
  homes3MiniProgramDesc: '线上字库 + 三大题型训练 + AI模拟对战，随时随地碎片化备赛。',
  homes3WebPlatform: '官网智学系统',
  homes3WebPlatformDesc: 'AI发音官 + 定制化课堂学习 + 模拟对战，以赛促学，以赛代练。',
  homes3ExploreBtn: '探索智学',

  homes4tit: '选手真实评价',

  // competition
  comps1tit: '报名资格',
  comps2tit: '比赛赛程',

  // ========== gameType keys ==========
  gameTypeAge: '年龄',
  gameTypeAgeDesc: '7-15岁且同时学习中文与英文的青少年。',
  gameTypeArea: '地区',
  gameTypeAreaDesc: '参赛区域应根据参赛者就读学校的所在地来确定。',
  gameTypeNationality: '国籍',
  gameTypeNationalityDesc: '不限国籍。',
  gameTypePreliminary: '城市初选',
  gameTypeCompetitionFormat: '比赛形式',
  gameTypeRecordingTest: '音频听力+笔试答题',
  gameTypeTimeLimit: '比赛时长',
  gameTypeTimeLimitVal: '20-30分钟',
  gameTypeCompetitionRules: '比赛规则',
  gameTypeCompetitionRulesDesc: '所有题型为单项选择题，选手需将正确的选项填写在题目前的括号内。',
  gameTypeSection1: '题型1',
  gameTypeSection1Desc: '根据录音和图片，选出正确的汉字。',
  gameTypeSection2: '题型2',
  gameTypeSection2Desc: '同音字甄别，选手需根据录音内容，选择出对应汉字的部首和部件。',
  gameTypeSection3: '题型3',
  gameTypeSection3Desc: '形近字辨析，选手需根据录音内容，选择出对应汉字部首和部件。',
  gameTypeSection4: '题型4',
  gameTypeSection4Desc: '寻找古字形，选手需根据录音内容，选择出对应汉字的篆书字形。',
  gameTypeSampleTest: '比赛例题（样卷）',
  gameTypeDownload: '下载',
  gameTypeNationalFinals: '国家/区域级比赛',
  gameTypeFormat1: '形式1',
  gameTypeFormat1Desc: '设备答题，授权组委会可使用比赛系统，在现场或远程操控播放考题，监测比赛进度；学生使用平板电脑或电脑登录指定网站，进入答题系统。',
  gameTypeFormat2: '形式2',
  gameTypeFormat2Desc: '口语拼词，此形式需在现场设置裁判席，总控1人，发音官1人，裁判考官1人，计时员1人，由发音官给出汉字相关线索，选手根据线索以及屏幕上的提示，选出2个选项组成正确的汉字。',
  gameTypeHomophone: '同音字甄别',
  gameTypeHomophoneDesc: '同音字甄别，选手需根据录音内容，选择出对应汉字的部首和部件。',
  gameTypeSimilarForm: '形近字辨析',
  gameTypeSimilarFormDesc: '形近字辨析，选手需根据录音内容，选择出对应汉字部首和部件。',
  gameTypeAncientFont: '寻找古字形',
  gameTypeAncientFontDesc: '寻找古字形，选手需根据录音内容，选择出对应汉字的篆书字形。',
  gameType1v1Spelling: '1v1拼字',
  gameType1v1SpellingDesc: '1v1拼字，发音官给出汉字拼音发音及英文释义后，选手在屏幕上选择组装汉字的部件。选手可通过提问获得相关线索，问题包括以下几种：',
  gameTypeQ1: 'Q1【Repeat, please】',
  gameTypeQ1Desc: '让发音官重新给出汉字的拼音发音。',
  gameTypeQ2: 'Q2【Tone, please】',
  gameTypeQ2Desc: '让发音官给出汉字的拼音声调。',
  gameTypeQ3: 'Q3【Pinyin, please】',
  gameTypeQ3Desc: '让发音官给出汉字的拼音拼写（包含声韵调），屏幕展示3秒。',
  gameTypeQ4: 'Q4【Ancient font, please】',
  gameTypeQ4Desc: '让发音官给出汉字的古字形，屏幕展示3秒。',
  gameTypeQ5: 'Q5【Translation, please】',
  gameTypeQ5Desc: '让发音官重新给出汉字的英文释义。',
  gameTypeQ6: 'Q6【Sentence, please】',
  gameTypeQ6Desc: '让发音官给出包含汉字句子的英文翻译。',
  gameTypeOnlineCompetition: '在线比赛',
  gameTypeGlobalFinals: '全球总决赛',
  gameTypeGlobalFinalsDesc1: 'CEBSB汉英双拼大会全球总决赛是年度最受瞩目的双语文化盛事，汇聚来自中国及世界各地的青少年，共同踏上一段探索汉字之美、体验中华文化的精彩旅程。',
  gameTypeGlobalFinalsDesc2: '活动以汉字为核心，通过趣味互动环节——如偏旁部首组合、同音字辨析、成语故事演绎等，让参与者在沉浸式体验中轻松掌握汉字的结构规律与文化内涵。同时，总决赛设有文化工作坊、传统技艺体验和主题交流活动，帮助海外学生更直观地感受中国历史与民俗的魅力。',
  gameTypeGlobalFinalsDesc3: '更重要的是，这是一座连接不同文化背景青少年的友谊之桥。各国选手在协作与分享中交流彼此的语言和文化，在理解中增进友谊，在互动中拓宽全球视野。全球总决赛，不止是一场学习之旅，更是一次难忘的文化交融体验。',
  gameTypeCity: '举办地点',
  gameTypeCityVal: '中国杭州',
  gameTypeDate: '时间',
  gameTypeDateVal: '10月30日-11月1日',
  gameTypeSchedule: '日程安排',
  gameTypeDay1: 'Day 1',
  gameTypeDay1Val: '注册报道&开幕式',
  gameTypeDay2: 'Day 2',
  gameTypeDay2Val: '比赛活动&晚宴&嘉年华',
  gameTypeDay3: 'Day 3',
  gameTypeDay3Val: '总决赛&颁奖盛典',
  gameTypeQualification: '全球总决赛选手资格',
  gameTypeRegistration: '注册',
  gameTypeRegisterNow: '点击报名',
  gameTypeFormat: '比赛形式',
  gameTypeLocation: '地点',
  gameTypeDivisionFinals: '分区决赛',
  gameTypeNationalFinalsRound: '全国总决赛',
  gameTypeDomF1V1: '笔试+听力',
  gameTypeDomF1V2: '2026年3月-6月',
  gameTypeDomF1V3: '校内/线上',
  gameTypeDomF2V1: '小程序答题',
  gameTypeDomF2V2: '2026年4月-9月',
  gameTypeDomF2V3: '校外/线上',
  gameTypeDomF3V1: '外教发音，智能答题系统+现场拼词',
  gameTypeDomF3V2: '2026年10月',
  gameTypeDomF3V3: '由组委会指定',
  gameTypeOverF1V1: '笔试+听力',
  gameTypeOverF1V2: '2026年1月-4月',
  gameTypeOverF1V3: '校内/线上',
  gameTypeOverF2V1: '小程序答题',
  gameTypeOverF2V2: '2026年4月-6月',
  gameTypeOverF2V3: '校外/线上',
  gameTypeOverF3V1: '外教发音，智能答题系统+现场拼词',
  gameTypeOverF3V2: '2026年10月',
  gameTypeOverF3V3: '由组委会指定',
  // ========== homes4 testimonial keys ==========
  homes4S1Username: '苏*桐',
  homes4S1Grade: '天津 七年级',
  homes4S1Content: '我一直在国际学校就读，校内课程以英文教学为主，爸妈总担心我的汉语母语松懈，所以参加了这个比赛。我是在北京参加的第一届总决赛。这个比赛是用英文线索拼中文汉字，这其实是我第一次去了解汉字背后的字形逻辑和文化故事，真切感受到了独属于汉字的美，我很感谢汉英双拼大会。',
  homes4S2Username: '周*珩',
  homes4S2Grade: '广州 六年级',
  homes4S2Content: '我的理想是以后可以成为具备双语沟通能力的外交官，备战汉英双拼大会的这段经历让我明白备赛过程比比赛本身更难忘。这个比赛涉及到汉字的篆书，因此除了字库本身的学习我还会自己查汉字的演变过程，遇到陌生的篆书时，我会自己查古籍资料和相关历史背景。在这个过程中我的学习视野变宽了，搜索能力也不知不觉提高了，我觉得这是我收获的最宝贵的经验。',
  homes4S3Username: '林*诺',
  homes4S3Grade: '杭州 四年级',
  homes4S3Content: '妈妈帮我报名了这个比赛，所以我完全没想到在这里可以交到朋友！去年在洛阳参加全国总决赛的时候，我认识了同组参赛的小伙伴，我们每天聊天，分享汉字故事和好用的记忆方法，遇到难一点的汉字部件就一起研究。比赛后我们也一直保持联系，除了交流学习，我们平时也分享生活。对我来说，比赛的名次只是锦上添花，能在这里遇见好朋友是我完全没想到的。',
  homes4S4Username: '李老师',
  homes4S4Grade: '北京 双语学校教师',
  homes4S4Content: '在国际学校任职，我很清楚很多学校普遍存在"重英语、轻中文"的问题。之前带四年级的孩子参加了汉英双拼大会，有三位进入了总决赛，我也到现场观赛了。整套赛事体系给我提供了新的课堂教学思路，英文释义和汉字辨析融为一体，很大程度上打通了中英双语教学的壁垒。现在听说还新增了AI智学系统，期待之后可以用于校本课和课后社团语言活动，丰富孩子们的校园学习体验。',
  homes4S5Username: 'Smith老师',
  homes4S5Grade: '新泽西 汉英双拼大会北美联盟赛带队教师',
  homes4S5Content: '作为北美沉浸式中文学校的汉语教师，我有幸带领学生参与了这次的北美联盟赛。在此之前，不少海外华裔青少年都会觉得汉语枯燥晦涩，认读汉字、区分拼读是长久以来的学习难点。但是此次的体验我认为打破了传统国际中文课堂的固有模式，赛事融合游戏化脑力竞技的形式，让孩子们愿意主动走近汉字。备赛过程中，孩子们从被动完成课业，到主动交流汉字知识，我很欣慰。CEBSB搭建了很好的平台，希望这套高效、有趣的学习模式能被带给更多中文学习者和文化交流者。',
  // ========== exerResult ==========
  exerResultEvent: 'Events',
  exerResultFunLearning: '趣味学习',
  exerResultPracticeComplete: '练习完成',
  exerResultTimeUsed: '完成用时',
  exerResultScore: '成绩',
  exerResultAttempts: '答题次数',
  exerResultDetails: '答题详情',
  exerResultIncomplete: '未完成',
  exerResultWrong: '错误',
  exerResultCorrect: '正确',
  // ========== eLearn ==========
  eleLearnStudent: '学生入口',
  eleLearnTeacher: '教师入口',
  eleLearnOrganizer: '组委会入口',
  eleLearnDesc: 'E‑Learn 是 CEBSB 汉英双拼大会专为参赛选手和指导教师打造的一站式智慧学习平台，涵盖学生端与教师端，以字库学习—题型训练—模拟实战为主线，帮助全球学习者在趣味互动中高效提升汉英双语素养。',
  // ========== eLearn Section2 ==========
  eleS2Title: '学生端',
  eleS2Subtitle: '线上字库 + 专项训练',
  eleS2RegDesc: '每位报名成功的海外选手，将直接获得官网专属字库的访问权限，无需任何实体材料，报名即开通。',
  eleS2C1Tit: '汉英双语数字字库',
  eleS2C1Desc: '字库以"字本位"理论为基础，收录汉字参照国际中文教育中文水平等级标准（HSK 1–9 级），覆盖了从初阶到高阶的常用汉字与词汇，同时注重汉字结构与文化解析，帮助学习者建立从"认字"到"用字"的完整认知链条，同时配套标准英文释义与发音，实现汉英双语联动学习。',
  eleS2C2Tit: '三大题型专项训练',
  eleS2C2Intro: '选手可在官网系统内直接进行核心题型练习：',
  eleS2C2Item1: '神奇偏旁',
  eleS2C2Item1Desc: '听音选择正确的汉字或偏旁',
  eleS2C2Item2: '魔力部首',
  eleS2C2Item2Desc: '听音选择正确的部首',
  eleS2C2Item3: '疯狂同音字',
  eleS2C2Item3Desc: '组合偏旁与部首构成正确汉字',
  eleS2C2Ending: '每轮练习随机组题，即时反馈正误，帮助选手在反复训练中加深对汉字音、形、义的理解。',
  eleS2C3Tit: 'AI 模拟对战',
  eleS2C3Desc: '内置 AI 对战系统，选手可随时发起模拟对战，在虚拟竞技场景中检验学习成果，提前适应比赛节奏与压力。',
  // ========== eLearn Section3 Teacher Portal ==========
  eleS3Title: '教师端',
  eleS3Subtitle: '定制化课堂系统',
  eleS3Intro: 'E-Learn 为指导教师提供专属授课系统，便于组织校内教学与选拔：',
  eleS3C1Tit: '班级与选手管理',
  eleS3C1Desc: '教师可创建班级、导入学生名单，实时查看全班学习进度与完成情况。',
  eleS3C2Tit: '课堂模拟对战',
  eleS3C2Desc: '在教室大屏或学生设备端发起模拟对战，支持个人赛与团体赛两种模式，还原真实竞技氛围，提升课堂参与度。',
  eleS3C3Tit: '定制化任务发布',
  eleS3C3Desc: '教师可根据教学进度，向全班或特定学生推送指定范围的练习任务。',
  // ========== eLearn Section4 Key Highlights ==========
  eleS4Title: '核心亮点',
  eleS4C1Tit: '报名即用',
  eleS4C1Desc: '无需等待实体材料，报名成功即可登录官网使用完整字库',
  eleS4C2Tit: '三级分级字库',
  eleS4C2Desc: '基于课标与 HSK 标准，适配海外不同中文水平的学习者',
  eleS4C3Tit: '学练测一体',
  eleS4C3Desc: '字库学习 → 题型训练 → AI 模拟对战 → 进度追踪，形成完整闭环',
  eleS4C4Tit: '教师端赋能',
  eleS4C4Desc: '支持课堂对战与学情管理，实现"以赛促学、以赛代练"',
  // ========== Global Finals Section1 ==========
  gfS1Title: '全球总决赛',
  gfS1Desc1: 'CEBSB全球总决赛是年度双语文化盛会，汇聚中国及世界各地的青少年，共同探索汉字之美与中华文化。',
  gfS1Desc2: '活动以汉字为核心，通过偏旁组合、同音字辨析、成语故事等趣味互动，让参与者在沉浸体验中掌握汉字结构与文化内涵。总决赛还设有文化工作坊与传统技艺体验，帮助海外学生直观感受中国历史与民俗。',
  gfS1Desc3: '更重要的是，这是一座连接不同文化背景青少年的友谊之桥。各国选手在协作交流中分享语言与文化，增进理解，拓宽视野。全球总决赛，是一次难忘的文化交融之旅。',
  // ========== Global Finals Section2 ==========
  gfS2Title: '第四季全球总决赛详情',
  gfS2City: '举办城市',
  gfS2CityVal: '中国杭州',
  gfS2Date: '举办时间',
  gfS2DateVal: '2026年10月30日 – 11月1日',
  gfS2Schedule: '日程安排',
  gfS2Activity: '活动',
  gfS2CheckIn: '签到注册、领取物料、酒店入住',
  gfS2Opening: '开幕式',
  gfS2GroupQualifying: '小组晋级赛',
  gfS2GroupChampionship: '组别争霸赛',
  gfS2GalaDinner: '全球社交晚宴',
  gfS2Bazaar: '汉文化集市街区',
  gfS2MixedFinals: '全球混合组别总决赛',
  gfS2Awards: '颁奖盛典',
  gfS2Arrangements: '总决赛住宿、交通、及相关安排，将在决赛前进行告知',
  gfS2SpecialEvents: '总决赛特色文化活动：中华文化交流营、中外选手联谊活动（敬请期待)',

  gfS3Title: '历届荣耀',
  // ========== Global Finals Section4 ==========
  gfS4Title: '总决赛奖项设置',
  gfS4Card1Tit: '个人总冠军',
  gfS4Card1Desc: '全球赛无组别比赛将角逐出全球总冠军、亚军、季军，并为选手颁发对应奖金和证书。',
  gfS4Card2Tit: '金银铜奖',
  gfS4Card2Desc: '有组别决赛将角逐出各个组别的冠军、亚军、季军，并为选手颁发对应奖励和证书。',
  gfS4Card3Tit: '单项题型奖',
  gfS4Card3Desc: '对于在特殊题型中表现特别优异的选手，组委会也将准备对应奖项颁发。',
  gfS4AwardDesc: '全球示范校、优秀组织学校、优秀指导教师奖项说明',
  gfS4ModelSchoolTit: '全球示范校',
  gfS4ModelSchoolDesc: '对于连续多年积极组织校园初选的学校，且连续多季有学生在比赛中取得优异成绩的学校，组委会将为其颁发"全球示范校"荣誉。',
  gfS4OrgTit: '优秀组织学校',
  gfS4OrgDesc: '对于连续多年积极组织校园初选的学校，组委会将为其颁发"优秀组织学校"荣誉。',
  gfS4InstructorTit: '优秀指导教师',
  gfS4InstructorDesc: '对于所指导选手在全球总决赛中取得名次的指导教师，组委会将为其颁发"优秀指导教师"荣誉。',
  gfS4CertTit: '赛事证书、奖杯、荣誉礼品展示',
  gfS4Cert1: '证书',
  gfS4Cert2: '奖杯',
  gfS4Cert3: '纪念品',

  // ========== Join Us Dialog ==========
  joinDialogTitle: '合作申请',
  joinFullName: '姓名',
  joinFullNamePh: '请输入您的姓名',
  joinCountry: '国家',
  joinCountryPh: '请选择您的国家',
  joinInstitution: '所属机构',
  joinInstitutionPh: '请输入学校或机构名称',
  joinEmail: '邮箱',
  joinEmailPh: '请输入邮箱地址',
  joinEmailRequired: '请输入邮箱地址',
  joinEmailInvalid: '请输入有效的邮箱地址',
  joinPurpose: '联系事由',
  joinPurposePh: '请描述您的联系事由',
  joinNote: '备注',
  joinNotePh: '补充说明（选填）',
  joinSuccess: '提交成功！我们将尽快与您联系。',
  // ========== Global Finals Registration Form ==========
  gfRegFormTitle: '填写参赛信息',
  gfRegFirstName: '名',
  gfRegFirstNamePh: '请输入您的名',
  gfRegLastName: '姓',
  gfRegLastNamePh: '请输入您的姓',
  gfRegNationality: '国籍',
  gfRegNationalityPh: '请选择国籍',
  gfRegCity: '城市',
  gfRegCityPh: '请输入所在城市',
  gfRegBirthDate: '出生日期',
  gfRegBirthDatePh: '请选择出生日期',
  gfRegTshirtSize: 'T恤尺码',
  gfRegTshirtSizePh: '请输入T恤尺码',
  gfRegParentsNum: '随行家长数量',
  gfRegParentsNumPh: '请输入随行家长数量',
  gfRegContactEmail: '联系邮箱',
  gfRegContactEmailPh: '请输入联系邮箱',
  gfRegEmailInvalid: '请输入有效的邮箱地址',
  gfRegSubmitSuccess: '提交成功！我们将尽快与您联系。',
  joinCooperationItems: '合作内容',
  joinScopeCategory: '合作内容类别',
  joinTeacherTraining: '教师培训',
  joinTeacherTrainingOrgDesc: '培训授权组委会/学校教师智学与活动组织细则，提供相应资料素材',
  joinTeacherTrainingSchoolDesc: '按时按要求接受项目培训',
  joinAiGamifiedLearning: 'AI 游戏化智学',
  joinAiLearningOrgDesc: '提供 AI 游戏化智学平台与相关账号维护',
  joinAiLearningSchoolDesc: '使用平台进行字库学习与汉英双拼游戏',
  joinCampusPreliminary: '校园海选',
  joinCampusOrgDesc: '提供海选试卷及其他资料',
  joinCampusSchoolDesc: '组织本区域内学生进行海选',
  joinNationalRegionalFinals: '国家/区域决赛',
  joinNationalOrgDesc: '提供必要的赛题支持与系统支持',
  joinNationalSchoolDesc: '组织本区域内学生参与并保障决赛符合全球组委会标准化',
  joinGlobalFinals: '全球总决赛',
  joinGlobalOrgDesc: '负责全球总决赛全方位落地支持与服务',
  joinGlobalSchoolDesc: '为活动提供必要的帮助',
  joinOrgCommittee: 'CEBSB 全球组委会',
  joinAuthCommittee: '授权组委会/学校',
  joinAuthModel: '授权模式',
  joinModel1Title: '模式一：国家/地区授权',
  joinModel2Title: '模式二：学校/机构赛点 ',
  joinModel1PositioningDesc: '面向海外各国的教育机构、国际中文教育组织，授予其在指定国家或地区的独家赛事运营权。该模式适用于希望在区域内建立赛事品牌影响力、构建本地化运营体系的教育机构。',
  joinModel2PositioningDesc: '面向海外开设中文课程的全日制中小学、国际学校或中文教育机构，授权其作为CEBSB官方赛点，在校内组织初选活动。该模式适用于希望以赛事丰富中文教学形式、提升学生双语能力的单体学校。',
  joinCooperationPositioning: '合作定位',
  joinBenefits: '权益价值',
  joinRegionalExclusive: '区域独家/优先授权',
  joinRegionalExclusiveDesc: '获得在指定国家或地区的赛事独家运营权或优先运营权。',
  joinBrandAuth: '品牌授权',
  joinBrandAuthDesc: '获得CEBSB官⽅品牌授权及区域合作伙伴⾝份。',
  joinFullProcessSupport: '全流程运营支持',
  joinFullProcessSupportDesc: '获得从赛事组织、宣传推⼴到选⼿招募的全流程标准化指导⽅案。',
  joinCompetitionFormatAuth: '赛制与内容授权',
  joinCompetitionFormatAuthDesc: '获得完整的赛程赛制⽅案、官⽅字库体系及题型设计。',
  joinGlobalFinalsPathway: '全球总决赛通道',
  joinGlobalFinalsPathwayDesc: '区域优胜选⼿可直接晋级全球总决选。',
  joinIntlResourceNetwork: '国际资源对接',
  joinIntlResourceNetworkDesc: '接⼊CEBSB全球合作⽹络，与各国教育机构建⽴联系。',
  joinTestCenterAuth: '官方赛点授权',
  joinTestCenterAuthDesc: '获得CEBSB官⽅赛点授权及认证。',
  joinCampusEventPlan: '校内赛事组织⽅案',
  joinCampusEventPlanDesc: '获得校内初选的组织⽅案、赛制规则与评审标准。',
  joinCharLibraryResources: '官方字库与学习资源',
  joinCharLibraryResourcesDesc: '接⼊CEBSB官⽅字库体系与AI智学⼯具。',
  joinAdvancementPathway: '选手晋级通道',
  joinAdvancementPathwayDesc: '校内优胜选⼿可获得晋级区域赛及全球总决选资格。',
  joinTeacherSupport: '教师支持',
  joinTeacherSupportDesc: '获得赛事相关的教师指导与教学资源。',
  joinCooperationApply: '合作申请',
  joinClickToFillIn: '点击填写',
  joinContactUs: '联系我们',
  joinPleaseFillInOnline: '请在线填写以下信息',
  joinDialogTitle2: '合作咨询',
  joinContactPerson: '合作联系人',
  joinContactPersonPh: '请输入合作联系人',
  joinPosition: '职务',
  joinPositionPh: '请输入职务',
  joinTel: '电话',
  joinTelPh: '请输入电话',
  joinEmail2Ph: '请输入邮箱',
  joinAddress: '联系地址',
  joinAddressPh: '请输入联系地址',
  joinSchool: '代表机构',
  joinSchoolPh: '请输入代表机构',
  joinInstitutionProfile: '机构简介',
  joinInstitutionProfilePh: '请输入机构简介'

}
